export default function useRepair() {
  const editClick = (id: string) => {
    console.log('edit click', id, 'id');
  };

  const refreshSend = () => {
    console.log('refresh send');
  };

  return {
    editClick,
    refreshSend,
  };
}
